import { RIJ_NOTITIE_MAX_LENGTH, RIJ_NOTITIE_MAX_WORDS } from "../constants";

const WORD_PATTERN = /\S+/g;

export function countRijNotitieWords(value) {
  return String(value || "").match(WORD_PATTERN)?.length || 0;
}

export function limitRijNotitie(value) {
  const text = String(value || "").slice(0, RIJ_NOTITIE_MAX_LENGTH);
  const words = Array.from(text.matchAll(WORD_PATTERN));

  if (words.length <= RIJ_NOTITIE_MAX_WORDS) return text;

  const lastAllowedWord = words[RIJ_NOTITIE_MAX_WORDS - 1];
  return text.slice(0, lastAllowedWord.index + lastAllowedWord[0].length);
}

export function normalizeRijNotitie(value) {
  const note = limitRijNotitie(value).trim();
  return note || null;
}
